export default "https://s3.eu-west-3.amazonaws.com/storage.wixar.io/logo_wixar.png";
